import { FieldInstance, FieldTemplate, FormGroup, FormInstance, FormTemplate } from "db/definitions";
import getFullFormInstance from "./getFullFormInstance";
import getFullFormTemplate from "./getFullFormTemplate";
import { recordSentry } from "./recordSentry";

async function getFullFormGroup(retrievedFormGroup: FormGroup, online: boolean) {
	const copyFormGroup = { ...retrievedFormGroup };
	const newInstances: (Promise<FormInstance | undefined> | FormInstance)[] = [];
	// First need to see if we have to paginate any of the instances.
	if (retrievedFormGroup.formInstances) {
		for (let i = 0; i < retrievedFormGroup.formInstances.items.length; i++) {
			const formInstance = retrievedFormGroup.formInstances.items[i];

			// Changes required here VVVVVVV
			// now we will always be retreiving the full form template.

			const fullFormInstance = handleRetrieveFullInstance(formInstance, online);
			if (fullFormInstance) newInstances.push(fullFormInstance);

			// if (formInstance.fieldInstances.nextToken) {
			// 	// it is a big one and needs to be handled.
			// 	newInstances.push(handleRetrieveFullInstance(formInstance, online));
			// } else {
			// 	// everything is already grabbed for the instance.
			// 	newInstances.push(formInstance);
			// }
		}
	}
	// If it does need pagination, then we need the fullFormTemplate and the fullFormInstance.
	// Make method to get fullFormInstance including the fullformTemplate
	// loop through the formInstances

	const final = await Promise.all(newInstances);
	if (!copyFormGroup.formInstances) {
		copyFormGroup.formInstances = { items: final.filter((fi): fi is FormInstance => fi !== undefined) };
	} else {
		copyFormGroup.formInstances.items = final.filter((fi): fi is FormInstance => fi !== undefined);
	}
	return copyFormGroup;
}

async function handleRetrieveFullInstance(formInstance: FormInstance, online: boolean): Promise<FormInstance | undefined> {
	//  need to grab the full form template
	const fullFormTemplate = await getFullFormTemplate(formInstance.formTemplateId, online);
	// need to grab all the field instances related
	const fullFormInstance = await getFullFormInstance(formInstance.id);

	if (fullFormTemplate && fullFormInstance) {
		// Table Cell fields could be missing the documents requested via pagination at this point so we really just need to make sure each fieldInstance
		// In the fullFormInstance has the fieldTemplate from the fullFormTemplate
		const finalFullFormInstance = matchFullTemplatesWithFullInstances(fullFormInstance, fullFormTemplate);
		// fullFormInstance.formTemplate = fullFormTemplate;
		return finalFullFormInstance;
	} else {
		// This really should never be hit.  To remove this we will need to make sure that all the dependency methods always return a form template.
		// right now the offline flow can be form template or void so well need to change that, otherwise we can leave this here and it should never be hit.
		recordSentry({ error: "Full Form Template wasnt retreived!" });
		return fullFormInstance;
	}
}

/**
 * Basically this relates more to cells in tables than anything else, but the field instances do not have the full retrieved teamplets attached
 * later in the process so this is to make sure the retrieved full form template is relatd to the correct field instance.
 * @param formInstance Forminstance that is being built
 * @param formTemplate the full form template that needs to be matche dup
 */
function matchFullTemplatesWithFullInstances(formInstance: FormInstance, formTemplate: FormTemplate) {
	// This could probably also be done when we retreive the instances, but I didnt want to mess with something that was working, so decided to do this method
	const fieldTemplateMap: { [key: string]: FieldTemplate } = {};
	const newFieldInstanceItems: FieldInstance[] = [];
	// The FUll Form template actually should have all the templates at this point in the fieldTemplates.items
	// Just need to map those out then loop through each field instance and reset the correct one on there
	if (formTemplate && formTemplate?.fieldTemplates?.items) {
		for (let i = 0; i < formTemplate.fieldTemplates.items.length; i++) {
			const fullFieldTemplate = formTemplate.fieldTemplates?.items[i];
			fieldTemplateMap[fullFieldTemplate.id] = fullFieldTemplate;
		}
	}

	if (formInstance && formInstance.fieldInstances.items) {
		for (let i = 0; i < formInstance.fieldInstances.items.length; i++) {
			const fieldInstanceToMatch = formInstance.fieldInstances.items[i];
			if (fieldInstanceToMatch?.fieldTemplate?.inputType === "table" || fieldInstanceToMatch?.fieldTemplate?.inputType === "imageroll") {
				// table/imageroll: match fieldTemplate onto each child instance
				let newTableFieldInstances: FieldInstance[] = [];
				for (let ii = 0; ii < fieldInstanceToMatch.tableFields.items.length; ii++) {
					const cellFieldInstance = fieldInstanceToMatch.tableFields.items[ii];
					if (cellFieldInstance?.fieldTemplateId) {
						const matchedFieldTemplate = fieldTemplateMap[cellFieldInstance.fieldTemplateId];
						cellFieldInstance.fieldTemplate = matchedFieldTemplate;
						newTableFieldInstances.push(cellFieldInstance);
					}
				}

				fieldInstanceToMatch.tableFields.items = newTableFieldInstances;
			}
			// Keep every instance, even one whose template id is null. Dropping those here used to hide the exact state
			// that must stop the repair step from creating a second set of fields (planMissingFieldInstances refuses when
			// any loaded instance has no template id). The renderer skips instances without a fieldTemplate.
			if (fieldInstanceToMatch) {
				if (fieldInstanceToMatch.fieldTemplateId) {
					const matchedFieldTemplate = fieldTemplateMap[fieldInstanceToMatch.fieldTemplateId];
					if (matchedFieldTemplate) fieldInstanceToMatch.fieldTemplate = matchedFieldTemplate;
				}
				newFieldInstanceItems.push(fieldInstanceToMatch);
			}
		}
	}

	const newFormInstance = formInstance;
	newFormInstance.fieldInstances.items = newFieldInstanceItems;
	newFormInstance.formTemplate = formTemplate;
	// Then also go through the table cells and put those on there
	// rebuild the object then return it.

	return newFormInstance;
}

export default getFullFormGroup;
